<mat-form-field appearance="outline" color="accent" floatLabel="always" [hideRequiredMarker]="hideRequiredMarker"
  [ngClass]="[
    isFullWide ? 'u-mat-full' : ''
  ]">
  <mat-label [matTooltip]="label">
    <ng-container *ngIf="required">{{ label }}</ng-container>
    <ng-container *ngIf="!required">{{ label | optionalFieldTranslate }}</ng-container>
    <app-bui-tooltip-icon *ngIf="tooltip"
      [tooltip]="tooltip">
    </app-bui-tooltip-icon>
  </mat-label>

  <ng-container *ngIf="!enableAutocomplete">
    <mat-select
      [panelClass]="panelClassVisible ? 'mat-select-panel-override' : ''"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [formControl]="$any(ngControl.control)"
      [multiple]="multiple"
      [disableOptionCentering]="true">
      <mat-option *ngFor="let option of options"
                  [value]="option.value"
                  (onSelectionChange)="selectionChanged.emit($event)">
        <ng-container
          [ngTemplateOutlet]="templateRef ? templateRef : defaultTemplate"
          [ngTemplateOutletContext]="{$implicit: option}">
        </ng-container>
      </mat-option>
    </mat-select>
  </ng-container>

  <ng-container *ngIf="enableAutocomplete">
    <input
      #searchInput
      type="text"
      matInput
      [placeholder]="placeholder"
      [required]="required"
      [disabled]="disabled"
      [formControl]="$any(ngControl.control)"
      [matAutocomplete]="auto"
      (focus)="onFocus($event)"
      (blur)="onBlur($event)"
      (input)="onInput($event)">

    <app-bui-button-icon
      [iconName]="'menu-down'"
      [comboStyle]="'naked-dark'"
      [disabled]="disabled">
    </app-bui-button-icon>

    <mat-autocomplete
      #auto="matAutocomplete"
      [autoActiveFirstOption]="!$any(ngControl.control)?.value"
      [displayWith]="displayFn.bind(this)"
      (optionSelected)="onAutocompleteOptionSelected($event, searchInput)"
      (opened)="onPanelOpened()">
      <mat-option *ngFor="let option of filteredOptions$ | async"
        [value]="option.value">
        <ng-container
          [ngTemplateOutlet]="templateRef ? templateRef : defaultTemplate"
          [ngTemplateOutletContext]="{$implicit: option}">
        </ng-container>
      </mat-option>
    </mat-autocomplete>
  </ng-container>

  <mat-error *ngIf="ngControl.errors?.required">{{ 'VALIDATIONS.FIELD_REQUIRED' | translate }}</mat-error>
  <mat-error *ngIf="ngControl.errors?.uniqueField">{{ 'VALIDATIONS.UNIQUE_FIELD' | translate }}</mat-error>
</mat-form-field>

<ng-template #defaultTemplate let-item>
  <div class="c-select__item" [matTooltip]="defaultTemplateTooltipVisible ? item?.data : ''">{{ item.data }}</div>
</ng-template>
